import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LibraryAddTwoToneIcon from '@mui/icons-material/LibraryAddTwoTone';
import LibraryAddCheckTwoToneIcon from '@mui/icons-material/LibraryAddCheckTwoTone';
import Button from '../../../components/button';

interface Props {
  onAddItem: (type: string) => void
}

const AddItemMenu = ({ onAddItem }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelect = (type: string) => {
    onAddItem(type);
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="add-item-button"
        aria-controls={open ? 'add-item-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        startIcon={<LibraryAddTwoToneIcon />}
      >
        Add Item
      </Button>
      <Menu
        id="add-item-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'add-item-button',
        }}
      >
        <MenuItem onClick={() => handleSelect('CheckboxField')}>
          <LibraryAddCheckTwoToneIcon fontSize="small" />
          <span style={{ marginLeft: 5 }}>Checkbox</span>
        </MenuItem>
        {/* <MenuItem onClick={() => handleSelect('YesNoField')}>
          <ThumbsUpDownTwoToneIcon fontSize="small" />
          <span style={{ marginLeft: 5 }}>Yes/No</span>
        </MenuItem> */}
      </Menu>
    </div>
  );
};

export default AddItemMenu;
